module.exports = __webpack_public_path__ + "static/media/KP_03.fc9f3282.jpg";